import React, {useState, useEffect} from 'react';

import { Col, Table } from "react-bootstrap";

import Liquidation from './Liquidation'
import Pagination from "react-pagination-bootstrap";

const Liquidations = ({loading, user, isAdmin, eventDownloadLiquidation, eventDeleteLiquidation}) => {

    if(!isAdmin){ isAdmin = false}

    const [pagination, setPagination] = useState({
        activePage: 1,
        pageRangeDisplayed: 12,
        data: []
    })

    useEffect(  () => {        
        
            if(user){
                setPagination({ 
                    ...pagination, 
                    totalItemsCount: user.liquidations.length,
                    data: paginate(user.liquidations, pagination.pageRangeDisplayed, pagination.activePage)
                })
            }
        // eslint-disable-next-line
    }, [user])

    const handlePageChange = (pageNumber) => {
        setPagination(
            {
                ...pagination, 
                activePage: pageNumber,
                data: paginate(user.liquidations, pagination.pageRangeDisplayed ,pageNumber)
            });            
      }

    const paginate = (array, page_size, page_number) => {
        return array.slice((page_number - 1) * page_size, page_number * page_size);
      }

    return ( 
        <>
            <Table responsive striped bordered hover size="sm" >
                <thead>
                    <tr>                                       
                        <th className="text-center">Período</th>
                        <th className="text-center">Comentario</th>
                        <th className="text-center">Descargar</th>
                        {isAdmin? <th className="text-center">Eliminar</th> : null}
                    </tr>
                </thead>
                <tbody>
                    
                    {loading ?  "Loading ...":
                    pagination.data.map((element, index) => (

                        <Liquidation 
                            isAdmin={isAdmin}
                            element={element}
                            eventDownloadLiquidation={eventDownloadLiquidation}
                            eventDeleteLiquidation={eventDeleteLiquidation}
                        />
                        
                    ))}
                
                </tbody>
            </Table>
            
            {loading? 
                    null:
                    <Col sm={{ span: 4, offset: 4}}>
                        
                        <Pagination  size="sm"
                            activePage={pagination.activePage}
                            itemsCountPerPage={pagination.itemsCountPerPage}
                            totalItemsCount={pagination.totalItemsCount}
                            pageRangeDisplayed={pagination.pageRangeDisplayed}
                            onChange={handlePageChange}
                            />

                    </Col>
                }
        </>
     );
}
 
export default Liquidations;